import React from 'react';
import ConfettiExplosion from 'react-confetti-explosion';

function Ending({overOrWin, handlingRestart}) {

    const bigExplodeProps = {
        force: 0.7,
        duration: 5000,
        particleCount: 300,
        width: 1600,
      };

  return (
    <div className="ending">
        {overOrWin &&
        <>
            <h1 style={{'color':'green'}}>Bravo ! Vous avez réussi le quizz !</h1>
            <ConfettiExplosion {...bigExplodeProps}/>      
            <div className="homescreen replay" onClick={()=> handlingRestart()}>
                <h2>Rejouer ?</h2>
            </div>
            <p style={{'textAlign':'center', 'color':'white'}}>Fait par <a style={{'color':'mediumspringgreen', 'textDecoration': 'none'}} target="_blank" href='https://guillaumeguichard.dev/' rel="noopener noreferrer">Guillaume Guichard 🔗</a></p>

        </>
        }
        {!overOrWin &&
        <>
            <h1 style={{'color':'red'}}>Perdu ! Toutes vos vies ont été épuisées !</h1>
            <div className="homescreen replay" onClick={()=> handlingRestart()}>
                <h2>Retenter votre chance ?</h2>
            </div>
            <p style={{'textAlign':'center', 'color':'white'}}>Fait par <a style={{'color':'mediumspringgreen', 'textDecoration': 'none'}} target="_blank" href='https://guillaumeguichard.dev/' rel="noopener noreferrer"><img style={{width:'20px', height:'20px', position:'relative', top:'3px', marginRight:'4px'}} src="/logogg.png" alt=""></img>Guillaume Guichard 🔗</a></p>

        </>
        }
    </div>
  )
}

export default Ending